const formDataSchema ={
    feilds: [{
        id: 1,
        name: 'user_name',
        text: 'User Name',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter',
        icon: 'number',
        rules: [
            {
                test: (value) => {
                    // return (value !== null && value.length > 0)
                    return true;
                },
                message: 'Please Enter User Name'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },{
        id: 2,
        name: 'user_id',
        text: 'User ID',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'text',
        placeholder: 'Enter',
        icon: 'number',
        rules: [
            {
                test: (value) => {
                    // return (value !== null && value.length > 0)
                    return true;
                },
                message: 'Please Enter User ID'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },  {
        id: 3,
        name: 'dateofbirth',
        text: 'Date of Birth',
        visible: true,
        element: 'date',
        required: true,
        input_type: 'date',
        placeholder: 'Select Date',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                },
                message: 'Please Select Date of Birth'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 4,
        name: 'gender',
        text: 'Gender',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Gender'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },{
        id: 5,
        name: 'phonenumber',
        text: 'Phone Number',
        visible: true,
        element: 'input',
        required: true,
        input_type: 'number',
        placeholder: 'Enter',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    var regex = /^\d{10}$/g;


                    if (value !== null && value.length > 0 && regex.test(value) === false) {
                        return false;
                    } else {
                        return true;
                    }
                },
                message: 'Please Enter valid Phone Number'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }, {
        id: 6,
        name: 'unit',
        text: 'Unit',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Select Unit'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    },, {
        id: 7,
        name: 'role',
        text: 'Role',
        visible: true,
        element: 'select2',
        required: true,
        input_type: 'select',
        placeholder: 'Select',
        icon: 'user',
        rules: [
            {
                test: (value) => {
                    return (value !== null && value.length > 0);
                    return true;
                },
                message: 'Please Select Role'
            }
        ],
        errors: [],
        value: null,
        valid: false,
        state: '',
        disable: false,
        className: 'col-4'
    }
       
    ]
}

export {formDataSchema};